import { useEffect, useState } from 'react';

/**
 * Mount an overlay, then add its `.open` class one painted frame later so the
 * CSS transition has a closed state to start from; on close, drop the class at
 * once and unmount when `exitMs` (the CSS exit duration) has passed.
 *
 * Returns [mounted, shown].
 */
const usePresence = (isOpen, exitMs) => {
    const [mounted, setMounted] = useState(isOpen);
    const [shown, setShown] = useState(false);

    useEffect(() => {
        if (isOpen) { setMounted(true); return undefined; }
        setShown(false);
        const timer = setTimeout(() => setMounted(false), exitMs);
        return () => clearTimeout(timer);
    }, [isOpen, exitMs]);

    useEffect(() => {
        if (!isOpen || !mounted) return undefined;
        let inner;
        const outer = requestAnimationFrame(() => { inner = requestAnimationFrame(() => setShown(true)); });
        return () => { cancelAnimationFrame(outer); cancelAnimationFrame(inner); };
    }, [isOpen, mounted]);

    return [mounted, shown];
};

export default usePresence;
